import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
const b = bemClassBuilder('v-button');
export const ButtonSkeleton = props => {
    const { className, size } = props;
    return _jsx("div", { className: b.block({ skeleton: true, size }, className) });
};
ButtonSkeleton.displayName = 'ButtonSkeleton';
//# sourceMappingURL=skeleton.js.map